/**
 * MPA 入口的挂载约定:每个物理 HTML 入口带一个 `<div id="root">` 与
 * 一个指向 src/entries/<page>.tsx 的 module script;入口文件只负责
 * 引入样式(shared-ui 设计令牌 + portal 本地样式)并挂载页面组件。
 */
import type { ComponentType } from 'react';
import { createRoot } from 'react-dom/client';
import '@web-v4/shared-ui/styles.css';
import '../site-chrome.css';
import '../main.css';

export function mount(Page: ComponentType): void {
  const container = document.getElementById('root');
  if (container === null) {
    throw new Error('portal entry: #root container missing in HTML entry');
  }
  createRoot(container).render(<Page />);
}
